import { useTheme } from '@emotion/react';
import React from 'react';

export const DownArrow = () => {
  const theme = useTheme();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      fill="none"
      viewBox="0 0 22 22"
    >
      <path
        stroke={theme.colors.ternary}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.909"
        d="M11 14.553V6"
      ></path>
      <circle
        cx="11"
        cy="11.001"
        r="10"
        stroke={theme.colors.ternary}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.909"
      ></circle>
      <path
        stroke={theme.colors.ternary}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.909"
        d="M15 11.553l-4 4-4-4"
      ></path>
    </svg>
  );
};
